
var sliderArray = {};
var copypasteConfig = {};
var keywordDensityConfig = {};
var customAcctName;
var pieColorPalette;
var edKeywordHighlights = {};
var activityTime = {};
var assignmentLimitParams = {};
var ezj = {};
var popupType;
var testSiteConnection = false;
var aemFieldList = {};
var siteType = {};
var listInputObj = {};
var statuses = [];

//var siteIds = {};
/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */


function sortAccountName(id) {
    var accName = $('#'+id).val();
    var selectBox = $('#'+id);
    selectBox.append(selectBox.find('option').sort(function(a, b) {
        return (
                a = $(a).text(),
                b = $(b).text(),
                a === b ? 0 : (a < b ? -1 : 1)
                );
    }));
    $('#'+id).val(accName);
}

function refreshSession(url, params, method, target) {
    $.ajax({
        type: "POST",
        url: "refreshSession.htm",
        data: "",
        dataType: "text",
        success: function(data) {
            if (data && data.indexOf("success") !== -1) {
                if (url && params) {
                    loadURL(url, params, method, target);
                } else if (url) {
                    window.location.href = url;
                } else {
                    window.location.reload();
                }
            }
        }
    });
}

/*
 * show boostrap alert box after the id param.
 */

function showAlertAfter(id, message, errName, errType) {
    var mceWarningDivId = '#' + id + '_warning';
    var haswarningDiv = $(mceWarningDivId).length;
    var msgTemplate = ezjHtmlTemplates.getTemplates('editorWarningMsg');
    var msgContent =  {id: errName + '_warning', message: message};
    var warningId = '';
    var fieldId = id;
    var fieldName = $('#' + fieldId + '_label').html();

    if (!haswarningDiv) {
        var msgWrapper = ezjHtmlTemplates.getTemplates('editorWarning');
        var wrapperContent = {id: id + '_warning', message: msgTemplate(msgContent)};
        if ($('#' + id + "_parent").length) {
            $(msgWrapper(wrapperContent)).insertBefore('#' + id + "_parent");
        } else {
            $(msgWrapper(wrapperContent)).insertBefore('#' + id);
        }

    } else {
        $(mceWarningDivId).append(msgTemplate(msgContent));
    }

    if (!$('#' + id).is(':visible')) {
        fieldId = fieldId + '_parent';
    }

    msgContent =  {id : warningId, message : message, fieldId : fieldId, fieldName : fieldName};

    if (errType == 'error') {
        warningId = id + '_' + errName + '_error';
        msgContent.id = warningId;
        var errorDivId = $('#edErrors').show();
        $(errorDivId).append(msgTemplate(msgContent));
        $("#submitBtn").attr("disabled", "disabled");
    } else {
        warningId = id + '_' + errName + '_warning';
        msgContent.id = warningId;
        if (!$('#edWarnings #' + warningId).length) {
            var warningDivId = $('#edWarnings').show();
            $(warningDivId).append(msgTemplate(msgContent));
        }
    }
}

function hideAlert(id, errName, errType) {
    var mceMsgCount = $('#' + id + '_warning [data-message="message"]').length;
    var warningMsgCount = $('#edWarnings [data-message="message"]').length;
    var errorMsgCount = $('#edErrors [data-message="message"]').length;
    if (mceMsgCount == 1) {
        $('#' + id + '_warning').remove();
    } else {
        $('#' + errName + "_warning").remove();
    }
    if (errType == 'error') {
        $('#edErrors #' + id + '_' + errName + "_error").remove();

        if (errorMsgCount == 1) {
            $('#edErrors').hide();
            $("#submitBtn").removeAttr("disabled");
        }
    } else {
        $('#edWarnings #' + id + '_' + errName + '_warning').remove();
        if (warningMsgCount == 1) {
            $('#edWarnings').hide();
        }
    }
}
function cleanTinymceWarningError() {
    $('#edWarnings').empty().hide();
    $('#edErrors').empty().hide();
    $("#submitBtn").removeAttr("disabled");
}

$('#role').change(function() {
    onRoleChange();
});

$("input[data-type='update']").click(function(e) {
    dataTypeBtnClick(e);
});

$("input[data-type='save']").click(function(e) {
    dataTypeBtnClick(e);
});

$("input[data-type='submit']").click(function(e) {
    dataTypeBtnClick(e);
});

$("input[data-type='return']").click(function(e) {
    dataTypeBtnClick(e);
});

function dataTypeBtnClick(e) {
    var data = {};
    var activeBtn = $('#' + e.target.getAttribute("id"));

    activeBtn.button('loading');

    //data = $('#updateFrm').serialize();
//    $.each(htmlEditorArray, function(index, value) {
//        data[index + '_wc'] = $("#ez-editor-count-wordcount-" + index).html() || $("#" + index + "-word-count").html();
//    });

    data['content_warning'] = $('#edWarnings').html();
    data['content_warning_count'] = $('#edWarnings [data-message="message"]').length;
    data['accountName'] = $('#accountName').val();
    data['role'] = $('#role').val();
    data['btnlabel'] = e.target.getAttribute("data-label");
    data['type'] = e.target.getAttribute("data-type");

    saveDataNow(data, activeBtn, 'updateFrm');
}


$("#saveBtn, #submitBtn, #returnBtn, #updateBtn, #updateAndNextBtn, #submitAndNextBtn").click(function(e) {

    if ('onLine' in  window.navigator && !window.navigator.onLine) {
            $("#statusMsg").html('You seem to be Offline.');
            $("#statusMsg").dialog({
                modal: true,
                title: "Network Connection",
                width: 500,
                height: 200,
                buttons: [{
                    text: "Close",
                    class: 'btn-link',
                    click: function() {
                        $(this).dialog("close");
                    }
                }]
            });       
    } else {
        saveUpdateReturnItem(e, $(this));
    }
});

$('#submitSingleBtn').on('click', function(){
    $('#submitBtn').trigger('click');
});

/**
 * TODO: REVIEW THIS
 * FOR CONTENT THIS METHOD IS NOT IN USE.
 * REFRE CONTENT TS
 * @param {*} e 
 * @param {*} activeBtn 
 */
function saveUpdateReturnItem(e, activeBtn) {
    var data = {};
    var btnLabel = activeBtn.data('btnType') || $.trim(activeBtn.text());
    var form = 'updateFrm';
    activeBtn.button('loading');
    currentAccountKey = ezdia.config.JS.currentAccountKey;

    if (e.target.value == 'Bulk Update') {
        form = 'bulkEditFrm';
        data['accountName'] = $('#accountName').val();
        data['role'] = $('#role').val();
        data['id'] = ''+getGridSelRow();
        data['type'] = 'bulkedit';
    } else {
        data['_id'] = ''+getGridSelRow();
        if ($.ezdia.config.iseditor) {
            tinyMCE.triggerSave();
        }
        var isValidate = validateFields(btnLabel);
        if(isValidate || !$("#"+form).valid()){
            activeBtn.button('reset');
            return false;
        }
        var totalTimeKey = currentAccountKey+'.desk.total.time';
        var startTimeKey = currentAccountKey+'.desk.start.time';
        var startTime = '';
        var totalTime = '';
        data['content_warning'] = $('#edWarnings').html();
        data['content_warning_count'] = $('#edWarnings [data-message="message"]').length;
        data['accountName'] = $('#accountName').val();
        data['role'] = $('#role').val();
        data['btnlabel'] = e.target.value;
        activityTime = ezdia.config.JS.activityTime;
        if (activityTime[startTimeKey]) {
            startTime = activityTime[startTimeKey];
            totalTime = activityTime[totalTimeKey];
        } else {
            startTime = localStorage[startTimeKey];
            totalTime = localStorage[totalTimeKey];
        }
        data['desk_start_time'] = startTime;
        data['desk_total_time'] = totalTime;
        data['desk_end_time'] = getCurrentDateTime();

        if (btnLabel == 'Return Item') {
            data['type'] = "return";
            data['returnItemName'] = $('input[name="returnOption"]:checked').attr('data-value');
            data['ret_comments'] = $('#ret_comments').val();
        } else if (btnLabel == 'Submit' || btnLabel == 'Submit And Next') {
            data['type'] = "submit";
            data['btnLabel'] = btnLabel;
            data['btnlabel'] = btnLabel;
        } else if (btnLabel == 'Update') {
            data['type'] = "update";
	} else if (btnLabel == 'Save') {
            data['type'] = "save";
        } else {
            return;
         }
    }
    saveDataNow(data, activeBtn, form);
}

function saveDataNow(data, activeBtn, form, QAObj) {
    popupType = undefined;
    var frm = $("#"+form);
    QAObj = QAObj || {};

    frm.ajaxSubmit({
        type: "POST",
        url: QAObj.actionUrl || "SaveData.htm",
        data: data,
        dataType: 'text',
        success: function(res) {
            $("#statusMsg").html(res);
            $("#statusMsg").dialog({
                modal: true,
                open: function(e, ui) {
                    $(".ui-dialog-titlebar-close", ui.dialog | ui).hide();
                },
                title: "Status Update",
                width: 950,
                minHeight: 0,
                create: function() {
                    $(this).css("maxHeight", 400);
                },
                buttons: [{
                    text: "Close",
                    class: 'btn-link',
                    click: function() {
                        $(this).dialog("close");
                        if (res.indexOf("successfully") != -1) {
                            $("#"+form).localStorage('discard');
                            
                            $('#footer_center').removeClass('ui-state-disabled');
                            hideShowDeskForm();

                            if (data.btnLabel === 'Submit And Next') {
                                ezdia.pages.content.resetGridData(data._id);
                            } else {
                                selectAllClick();
                                $("#grid").trigger("reloadGrid");
                                $('#selectAll').prop('checked', false);
                            }
                        }
                    }
                }]
            });
            if (popupType === 'reviewupdate') {
                var dialoguttons = [{
                    text: "Cancel",
                    class: 'btn-link',
                    click: function() {
                        $(this).dialog("close");
                        var data = {};
                        data['accountName'] = $('#accountName').val();
                        data['role'] = $('#role').val();
                        data['id'] = ''+getGridSelRow();
                        data['type'] = 'bulkedit';
                        data['ignoreWarningFlag'] = false;
                        //data = $('#bulkEditFrm').serialize();
                        if ($("#quickaction").val() == 'accept_tasks') {
                            data['assignmentTasks'] = true;
                        }
                        data['confirmChange'] = true;
                        saveDataNow(data, '', 'bulkEditFrm');                      
                    }
                }, {
                    text: "Confirm",
                    class: 'btn-primary',
                    click: function() {
                        $(this).dialog("close");
                    }
                }];
                $('#statusMsg').dialog('option', 'buttons', dialoguttons);
            }
            if (activeBtn) {
                activeBtn.button('reset');
            }
        },
        error: function(res) {
            var html = res;
            
            if (typeof res === 'object' && res.status === 0) {
                html = 'You seem to be Offline.';
            }
            
            $("#statusMsg").html(html);
            $("#statusMsg").dialog({
                modal: true,
                title: "Status Update",
                width: 500,
                height: 400,
                buttons: {
                    Ok: function() {
                        $(this).dialog("close");
                    }
                }
            });
            if (activeBtn) {
                activeBtn.button('reset');
            }
        }
    });
}

// TODO: REMOVE THIS

$("#returnItemBtn").click(function(e) {
    var activeBtn = $(this);

    var config = $.ezdia.config.pageParams;
    var returnOptions = config.returnOptions;
    var currentStatus = config.currentStatus;
    if ($.isEmptyObject(returnOptions)) {
        alert("Status Update", "No return options are available for the item");
        return false;
    }
    if (roleType == 'pm' || (currentStatus && (currentStatus.indexOf('Assigned') != -1 || currentStatus.indexOf('Saved') != -1 || currentStatus.indexOf('Reopened') != -1 || currentStatus.indexOf('Reassigned') != -1 || currentStatus.indexOf('New') != -1))) {
        var html = '';
        if (!$.isEmptyObject(returnOptions)) {
            html = '<p class="muted">Please select a reason to return item.<p>';
            var i = 0;            $.each(returnOptions, function(r, returnItem) {
                var checked = !r;
                var inputs = $('<input>', {
                type: "radio",
                name: "returnOption",
                id: "returnOption" + i,
                value: returnItem.role,
                "data-value": returnItem.name,
                "checked": checked
                }).prop('outerHTML');

                html += '<label class="radio">' + inputs + returnItem.label + '</label>';
                i++;
            });
            html += "<textarea rows='4' id='ret_comments' name='ret_comments' class='form-control' placeholder='Comments'></textarea>";
            html += "</div>";

            $("#statusMsg").html(html);
            $("#statusMsg").dialog({
                modal: true,
                width: '400',
                title: "Status Update",
                buttons: {
                    Ok: function() {
                        var returnRole = $('input[name="returnOption"]:checked').val();
                        var returnDataVal = $('input[name="returnOption"]:checked').attr('data-value');
                        $(this).dialog("close");
                        if (returnRole) {
                            $('#ez-return-comments').val($('#ret_comments').val());
                            if (roleType == 'pm' && returnDataVal == 'open_project') {
                                returnToOpenProjects(returnRole);
                            }
                            else if (returnRole == 'open_project') {
                                returnToOpenProjects(role);
                            } else {
                                saveUpdateReturnItem(e, activeBtn);
                            }
                        }
                    },
                    Cancel: function() {
                        $(this).dialog("close");
                    }
                }
            });
        }
    }
    else {
        $("#statusMsg").html('Whoa! You can only edit items that are Assigned, Saved, or Reopened.');
        $("#statusMsg").dialog({
            modal: true,
            width: 'auto',
            title: "Status Update",
            buttons: {
                Ok: function() {
                    $(this).dialog("close");
                }
            }
        });
    }
});

function uploadFile(id, form) {
    var elem = $('#upload_' + id);
    var fileName = elem.val();
    var frm = "";
    if (!fileName) {
        alert("Error", "Please select file");
        return;
    }
    if (form) {
        frm = elem.closest("form");
    } else {
        frm = $("#updateFrm");
    }

    var data = "type=submit";
    if ($('#accountName').val()) {
        data += "&accountName=" + $('#accountName').val();
    }
    if ($('#roleName').val()) {
        data += "&role=" + $('#roleName').val();
    }
    data += "&fieldName=" + id;

    frm.ajaxForm({
        url: "ImageUpload.htm",
        type: "POST",
        data: data,
        dataType: 'text',
        target: "#imageUrlDiv_" + id,
        success: function (response) {
            response = response.trim();
            $('#' + id).val(response);
            $('#' + id + '_href').attr('href', response);
            $('#upload_' + id).val('');
            $.each(response.split(","), function (i, mval) {
                $("#imageUrlDiv_" + id).html('<a style="cursor: pointer;" href="' + mval + '" target="_blank">' + mval + '</a>');
            });
	    frm.ajaxFormUnbind();
        },
        error: function (response) {
	    frm.ajaxFormUnbind();
            console.log("there is an error in uploading image");
        }
    }).submit();
    return false;
}

// TODO: REMOVE THIS
function returnToOpenProjects(role) {
    var msg = '<tr><td>You are about to return this item back to Open Projects Queue.</td></tr><tr><td>Are you sure you want to do this?</td></tr>';
    var activeBtn = $(this);
    $("#statusMsg").html(msg);
    $("#statusMsg").dialog({
        modal: true,
        width: 'auto',
        title: "Confirm",
        buttons: {
            YES: function() {
                $(this).dialog("close");
                returnToQueueConfirm(activeBtn, role);
            },
            NO: function() {
                $(this).dialog("close");
            }
        }
    });
}

// TODO: REMOVE THIS
function returnToQueueConfirm(activeBtn, role) {
    var data = "&accountName=" + $('#accountName').val();
    data += "&role=" + role;
    data += "&returnedByRole=" + $('#role').val();;
    data += "&id=" + getGridSelRow();
    data += "&type='returnToQueue'";
    data += "&ret_comments=" + $('#ez-return-comments').val();
    //data += "&comments=" + $('#feedbackComments').val();
    activeBtn.button('loading');

    $.ajax({
        type: "POST",
        url: "ReturnToQueue.htm",
        data: data,
        dataType: 'text',
        success: function(data) {
            $("#statusMsg").html(data);
            $("#statusMsg").dialog({
                modal: true,
                width: 'auto',
                title: "Status Update",
                buttons: {
                    Ok: function() {
                        $(this).dialog("close");
                        if (data.indexOf("successfully") != -1) {
                            $("#grid").trigger("reloadGrid");
                            $("#content").html('');
                            $("#bulkEditFrm").hide();
                            $("#updateBtnContainer").hide();
                            cleanTinymceWarningError();
                        }
                    }
                }
            });
        },
        error: function(data) {
            $("#statusMsg").html(data);
            $("#statusMsg").dialog({
                modal: true,
                title: "Status Update",
                buttons: {
                    Ok: function() {
                        $(this).dialog("close");
                    }
                }
            });
        }
    }).always(function() {
        activeBtn.button('reset')
    });
}
// TODO: REMOVE THIS
$("#downloadWordDocBtn").click(function() {
    var id = getGridSelRow();
    var url = 'wordDownload.htm';
    $.fileDownload(url, {
        failMessageHtml: "There was a problem generating the document, please try again.",
        httpMethod: "POST",
        datatype: "json",
        data: {
            accountName: function() {
                return escape($('#accountName').val());
            },
            role: function() {
                return escape($('#role').val());
            },
            id: function() {
                return id;
            }
        },
        failCallback: function(responseHtml, url) {
            alert("Error");
            $("#error-modal").dialog({modal: true});
        }
    });
});

function getAllItemIds() {
    var account = $.ezdia.config.pageParams.account;
    var role = $.ezdia.config.pageParams.role;
    var itemIds = '';
    var data = "&accountName=" + account || $('#accountName').val();
    data += "&roleName=" + role || $('#role').val();
    data += "&searchString=" + getSearchQueryString();

    $.ajax({
        type: "POST",
        url: "listItemIds.htm",
        data: data,
        async: false,
        dataType: 'json',
        success: function(response) {
            itemIds = response;
        },
        error: function() {
            itemIds = '';
        }
    });
    return itemIds;
}

function copy(from, to) {
    var cur_val = $("#" + to).val();
    $("#" + to).val(cur_val + $("#" + from).html());
}

function copyMulti(from, to) {
    $("#" + to).val($("#" + from).val() != null ? $("#" + from).val().join('') + '##' : '');
}

$(document).on("submit", "form.form-inline", function(e) {
    //$("#searchBtn").trigger('click');
     //otherwise a normal form submit would occur
    e.preventDefault();
});

function selectAllClick(e) {
  ezdia.component.grid.onSelectAllClick(e);
}

function submitQuickAction(e, QAObj, isEzAnalytics) {
    var template = $.ezdia.template.get('base-qa-confirm-changes-msg');
    var wrapper = $.ezdia.getWrapper('ez-dialog-confirm');
    var selIds = getGridSelRow();
    var selectAll = $('#selectAll').is(':checked');
    var displayArray = [];
    var copySupport = document.execCommand('copy');
    var targetID = e.target.getAttribute("data-type");
    
    if (selectAll) {
        selIds = getAllItemIds().split(",");
    }

    if (e.target.getAttribute("id") === 'Export' && !isEzAnalytics) {
        return;
    }

    if (QAObj.config && QAObj.config.export_enable === 'true') {
        return;
    }
    
    var isMany = selIds.length > 10;
    
    if (isMany) {
        displayArray = selIds.slice(0, 9);
    } else {
        displayArray = selIds;
    }
    
    var msg = template({
        allIds: selIds.join(', '),
        lessIds: displayArray.join(', '),
        isMany: isMany,
        copySupport: copySupport
    });
    
    wrapper.html(QAObj.confirmMsg || msg);
        
    if (isMany)  {
        var btn = wrapper.find('button');
       
        btn.on('click', function() {
            var $this = $(this);
            $this.closest('span[data-container]').hide().siblings('span[data-container]').show();
        });
    }
    
    var copyText = wrapper.find('#ezdia-copy-field')[0];
    wrapper.find('[data-button="copy"]').on('click', function() {
        copyText.select();
        document.execCommand("Copy");
        $.ezdia.showSuccessError({
            message: 'Ids copied to clipboard'
        });       
    });
    
    wrapper.dialog({
        resizable: false,
        modal: true,
        title: QAObj.confirmMsgTitle || "Confirm Changes",
        width: 600,
        maxHeight: 400,
        buttons: [{
            text: "Cancel",
            class: 'btn-link',
            click: function() {
                $( this ).dialog( "close" );
                if( targetID == "eza_mark_added" || targetID == "eza_send_for_optimization" || e.target.getAttribute("data-isezanalytics")) {
                    ezdia.component.quickActions.resetQuickActionLink();
                    $("#quickactionfield").empty();
                }
            }
        }, {
            text: 'Confirm',
            class: 'btn-primary',
            click: function(){
                $(this).dialog("close");
                if(isEzAnalytics){
                    saveEZQuickAction(e, QAObj);
                } else {
                    saveQuickAction(e, QAObj);
                }
            }
        }]
    });

}

function saveEZQuickAction(e, QAObj) {
    popupType = undefined;
    var pageParams = $.ezdia.config.pageParams;
    var form = $("#bulkEditFrm");
    var data = '';
    var activeBtn = $('#' + e.target.getAttribute("id"));
    var targetID = e.target.getAttribute("data-type");
    var selIds = getGridSelRow();
    var selectAll = $('#selectAll').is(':checked');
    if (selectAll) {
        selIds = getAllItemIds();
    }
    
    var action = ezdia.config.currentQuickAction;

    if (!form.valid()) {
        return false;
    }

    activeBtn.button('loading');
    data = form.serialize();
    data += "&formtype=" + pageParams.formType;
    data += "&ids=" + selIds;
    data += "&quickActionName=" + action;
    data += "&btnlabel=" + e.target.id;

    $.ajax({
        type: "POST",
        url: QAObj.actionUrl,
        data: data,
        dataType: 'text',
        success: function(data) {
            var responseData;
            try {
                responseData = data? JSON.parse(data): data;
            } catch(ex) {
                responseData = data;
            }
            var successMsg = responseData.msg;
            
            $("#statusMsg").html(successMsg);
            $("#statusMsg").dialog({
                modal: true,
                title: "Status Update",
                width: 500,
                height: "auto",
                buttons: {
                    Ok: function() {
                        $(this).dialog("close");
                        $("#grid").trigger("reloadGrid");
                        $("#content").html('');
                        $("#bulkEditFrm").hide();
                        $("#updateBtnContainer").hide();
                        hideShowDeskForm();
                    }
                }
            });
        },
        error: function(data) {
            $("#statusMsg").html(QAObj.error || "An error occurred while processing your request. Please try again.");
            $("#statusMsg").dialog({
                modal: true,
                title: "Status Update",
                buttons: {
                    "Ok": function() {
                        $(this).dialog("close");
                    }
                }
            });
        }
    }).always(function() {
        activeBtn.button('reset');
        if( targetID == "eza_mark_added" || targetID == "eza_send_for_optimization" || e.target.getAttribute("data-isezanalytics")) {
            ezdia.component.quickActions.resetQuickActionLink();
            $("#quickactionfield").empty();
        }
    });

}

function getDiffIds() {
    var checkedValue = []; 
    var inputElements = document.getElementsByClassName('diff-checkbox');
    for(var i = 0; inputElements[i]; ++i) {
      var element = inputElements[i];
      var id = element.id && element.id.split('diff_item_');
      id = id[1]? id[1] : "";
      if(element.checked) {
           checkedValue.push(id);
      }
    }
    
    return checkedValue.join(",");
}

function saveQuickAction(e, QAObj, parentPopUp) {
    popupType = undefined;
    var pageParams = $.ezdia.config.pageParams;
    var form = $("#bulkEditFrm");   
    var data = '';
    var activeBtn = $('#' + e.target.getAttribute("id"));
    var selIds = getGridSelRow();
    var selectAll = $('#selectAll').is(':checked');
    if (selectAll) {
        selIds = getAllItemIds();
    }
    var account = pageParams.account || $('#accountName').val();
    var role = pageParams.role || $('#role').val();
    var action = ezdia.config.currentQuickAction;
    
    if (!form.valid()) {
        return false;
    }

    activeBtn.button('loading');
    data = form.serialize();
    data += "&accountName=" + account;
    data += "&role=" + role;
    data += "&id=" + (QAObj.selIds || selIds);
    data += "&type=bulkedit";
    data += "&action=" + action;
    data += "&btnlabel=" + e.target.getAttribute("name");
    if (pageParams.userManagement) {
        data += "&userManagement=" + pageParams.userManagement;
    }

    if(QAObj.subAction) {
        var errorDiff = $(".error-diff");
        errorDiff.hide();
        data += "&subaction=" + QAObj.subAction;
        var popupIds = getDiffIds();
        if(QAObj.subAction === "merge" && !popupIds) {
            errorDiff.show();
            return;
        }
        data += "&selectedIds=" + popupIds;
    }
    
    $.ajax({
    type: 'POST',
    url: QAObj.actionUrl || 'SaveData.htm',
    data: data,
    dataType: 'text',
    success: function (data) {
        if(QAObj.configMap && QAObj.configMap.type === 'ezoDiff' && QAObj.subAction) {
           showDiffPopUp(data,QAObj,e,parentPopUp);   
           delete QAObj.subAction;
        } else if (QAObj.configMap && QAObj.configMap.type === 'ezoDiff') {
            showDiffPopUp(data,QAObj,e,parentPopUp);            
        } else {
            var successMsg = data;

            if (!QAObj.reviewChanges && QAObj.successMsg && data.indexOf("successfully") !== -1) {
                successMsg = QAObj.successMsg;
            } else if (data.indexOf("msg") !== -1 && data.indexOf("success") !== -1){
                var resobj = ezdia.util.jsonParse(data);
                successMsg = resobj.msg;
            }

            showPopUp(successMsg,QAObj,data,account,role,selIds,action);
        }
    },
        error: function(data) {
            $("#statusMsg").html(QAObj.error || data);
            $("#statusMsg").dialog({
                modal: true,
                title: "Status Update",
                buttons: {
                    "Ok": function() {
                        $(this).dialog("close");
                    }
                }
            });
        }
    }).always(function() {
        activeBtn.button('reset');
    });
    
}

function showPopUp(successMsg, QAObj, data, account, role, selIds, action, parentPopUp) {
    $("#statusMsg").html(successMsg);
            $("#statusMsg").dialog({
                modal: true,
                title: "Status Update",
                width: 500,
                height: 400,
                buttons: {
                    Ok: function() {
                        $(this).dialog("close");
                        if(QAObj.configMap && QAObj.configMap.type == 'ezoDiff') {
                            if(parentPopUp) {
                                parentPopUp.dialog("close");
                            }
                        } else {    
                            if (data.indexOf("successfully") !== -1) {
                                $("#grid").trigger("reloadGrid");
                                $("#content").html('');
                                $("#bulkEditFrm").hide();
                                $("#updateBtnContainer").hide();
                                hideShowDeskForm();
                                $('#selectAll').prop('checked', false);
                                selectAllClick();
                            }
                        }
                    }
                }
            });
            if (popupType === 'reviewupdate' || QAObj.reviewChanges) {
                QAObj.reviewChanges = false;
                var dialoguttons = [{
                    text: "Cancel",
                    class: 'btn-link',
                    click: function() {
                        $(this).dialog("close");
                    }
                }, {
                    text: "Confirm",
                    class: 'btn-primary',
                    click: function() {
                        $(this).dialog("close");
                        var data = {
                            accountName: account,
                            role: role,
                            id: ''+selIds,
                            type: 'bulkedit',
                            ignoreWarningFlag: false,
                            action: action,
                            confirmChange: true
                        };

                        if ($("#quickaction").val() == 'accept_tasks') {
                            data.assignmentTasks = true;
                        }

                        saveDataNow(data, '', 'bulkEditFrm', QAObj);
                    }
                }];
                $('#statusMsg').dialog('option', 'buttons', dialoguttons);
       }
}

function showDiffPopUp(data,QAObj,e,parentPopUp){
    try {
        data = data.trim();
        data = data.replace("<br>","");
        data = JSON.parse(data);
        
        if(data.unpublished_data) {
            ezdia.createDiffPopUp.create({
                type: 'diff',
                data: data,
                id: 'ez-diff-popup',
                qaObj: QAObj,
                action: saveQuickAction,
                eventObject: e
            });
        } else {
            var successMsg = "";
            successMsg += data.published_tems ? data.published_tems : "";
            successMsg += data.reviewable_items ? data.reviewable_items : "";
            successMsg += data.invalid_items ? data.invalid_items : "";
            successMsg += data.task_result? data.task_result : "";
            showPopUp(successMsg,QAObj,data, null,null,null,null,parentPopUp);
        }
    }
    catch (e) {
        showPopUp(data,QAObj,data, null,null,null,null,parentPopUp);
    }
}

function alert(title, msg) {
    $("<div></div>").dialog({
        open: function(e, ui) {
            $(e.target).closest('.ui-dialog')
                .css('z-index', 999999999)
                .prev('.ui-widget-overlay')
                .css('z-index', 999999999);
        },
        buttons: [{
            text: "Close",
            class: 'btn-link',
            click: function() {
                $( this ).dialog( "close" );
            }
        }],
        close: function(event, ui) {
            $(this).remove();
        },
        resizable: false,
        title: title,
        modal: true
    }).text(msg);
}

$("#profile").click(function() {
    var activeBtn = $(this);
    activeBtn.button('loading');
    $.ajax({
        type: "GET",
        url: 'getprofile.htm',
        data: 'accountName=' + $('#accountName').val(),
        dataType: 'json',
        success: function(response) {
            var html = '';
            if (response && response.SUCCESS && response.SUCCESS.length > 0) {
                response = response.SUCCESS;
                html += '<form id="profileEditFrm"><table>';
                for (var f = 0; f < response.length; f++) {
                    var value = response[f].value ? response[f].value : "";
                    html += '<tr><td>' + response[f].label + '</td><td><input name="' + response[f].name + '" type="' + response[f].type + '" value="' + value + '"/></td></tr>'
                }
                html += '</table></form>';

            }
            else if (response && response.ERROR) {
                html += response.ERROR;
            }
            $("#statusMsg").html(html);
            $("#statusMsg").dialog({
                modal: true,
                title: "My Account",
                buttons: {
                    "Save": function() {
                        $.ajax({
                            type: "POST",
                            url: 'updateprofile.htm',
                            data: $('#profileEditFrm').serialize() + '&accountName=' + $('#accountName').val(),
                            dataType: 'json',
                            success: function(response) {
                                if (response.name == 'SUCCESS') {
                                    $("#statusMsg").html(response.value);
                                }
                                if (response.name == 'ERROR') {
                                    $("#statusMsg").html(response.value);
                                }
                                $("#statusMsg").dialog({
                                    modal: true,
                                    title: response.name,
                                    buttons: {
                                        Ok: function() {
                                            $(this).dialog("close");
                                        }
                                    }
                                });
                            },
                            error: function(response) {
                                $("#statusMsg").html(response);
                                $("#statusMsg").dialog({
                                    modal: true,
                                    title: "Error",
                                    buttons: {
                                        Ok: function() {
                                            $(this).dialog("close");
                                        }
                                    }
                                });
                            }
                        });
                    },
                    "Cancel": function() {
                        $(this).dialog("close");
                    }
                }});
        }
    }).always(function() {
        activeBtn.button('reset')
    });
});

$("#createanorder").click(function() {
    var activeBtn = $(this);
    activeBtn.button('loading');

    $.ajax({
        type: "GET",
        url: 'createanorder.htm',
        data: 'accountName=' + $('#accountName').val(),
        success: function(response) {
            $("#statusMsg").html(response);
            $("#statusMsg").dialog({
                modal: true,
                width: 'auto',
                height: 'auto',
                title: "Create An Order",
                resize: false,
                buttons: {
                    Save: function() {
                        $.ajax({
                            type: "POST",
                            url: 'createorder.htm',
                            data: $('#createorderfoem').serialize() + '&accountName=' + $('#accountName').val() + '&dialogflag=true',
                            success: function(response) {
                                $("#createorderfoem").html(response);
                            },
                            error: function(response) {
                                $("#createorderfoem").html(response);
                            }
                        });
                    },
                    Cancel: function() {
                        $(this).dialog("close");
                    }
                }
            });
        }
    }).always(function() {
        activeBtn.button('reset');
    });
});

$("#updateAssignmentLimitBtn").click(function() {
    var activeBtn = $(this);
    activeBtn.button('loading');
    var userNameList = [];
    var selIds = getGridSelRow();
    $.each(selIds, function(i){
	var rowData = $("#grid").jqGrid('getRowData', selIds[i]);
	var id = getDataFromString(rowData['username']);
	userNameList.push(parseInt(id));
    });
    var multiSelect = selIds.length > 1;
    var queryString='[]';
    if (assignmentLimitCounter > 0) {
        queryString = getAssignmentLimitString(multiSelect);
    }

    if (queryString == '[]') {
        alert("Please provide Limit or Lifetime Limit or Rework Percentage for selected users");
        activeBtn.button('reset');
        return;
    }

    $.ajax({
        type: "POST",
        url: 'SaveAssignmentLimit.htm',
        datatype: 'json',
        data: {
            query: queryString,
	    userName: JSON.stringify(userNameList),
            timeLimit: false
	},
        success: function(data) {
            $("#statusMsg").html(data.SUCCESS);
            $("#statusMsg").dialog({
                modal: true,
                width: '300',
                height: 200,
                title: "Save Assignment Limit",
                buttons: {
                    Ok: function() {
                        $(this).dialog("close");
                    }
                }
            });
        },
        error: function(data) {
            $("#statusMsg").html(data);
            $("#statusMsg").dialog({
                modal: true,
                width: '300',
                height: 200,
                title: "Save Assignment Limit",
                buttons: {
                    Ok: function() {
                        $(this).dialog("close");
                    }
                }
            });
        }
    }).always(function () {
      activeBtn.button('reset')
    });
});

function getAssignmentLimitString() {
    var entryObj = [];
    for (var count = 0; count < assignmentLimitCounter; count++) {
	var jsonvalue = {};
        var limitAccountName = $("#accountName" + count).val();
        var limitRole = $("#role" + count).val();
	var limit = $("#assignmentLimit" + count).val();
        var lifetimeLimit = $("#lifetimeLimit" + count).val() || -1;
        var reworkPercentage = $("#reworkPercentage" + count).val() || -1;

        if (!limitAccountName) {
            continue;
        }

        if (limitAccountName && limitRole && ((limit && limit > 0) || lifetimeLimit > -1) ) {
            if (!limit) {
                limit = lifetimeLimit;
            }
	    jsonvalue.accountName = limitAccountName;
            jsonvalue.role = limitRole;
            jsonvalue.assignmentLimit = limit;
            jsonvalue.lifetimeLimit = lifetimeLimit;
            jsonvalue.reworkPercentage = reworkPercentage;
            jsonvalue.timeSpan = 0;
            jsonvalue.createdByRole = role;
            jsonvalue.createdBy = email;
            jsonvalue.id = -1;
            jsonvalue.type = '';
            entryObj.push(jsonvalue);
	}
    }
    return JSON.stringify(entryObj);
}

function userWorkProfileQAClick() {
    var selIds = getGridSelRow();
    var selectAll = $('#selectAll').is(':checked');
    if (selectAll || (selIds && selIds.length > 1)) {
        alert("Error", "Please select only one item");
        return;
    } else if (!selIds || selIds.length == 0) {
	alert("Error", "Please select an item");
	return;
    }
    if(selIds.length == 1) {
        hideShowDeskForm();
	var rowData = $("#grid").jqGrid('getRowData', selIds);
	var id = getDataFromString(rowData['username']);
	var data = "&uid=" + id;
	$.ajax({
	    type: "POST",
	    url: "fetchUserWorkProfile.htm",
	    data: data,
	    dataType: 'json',
	    success: function(response) {
                var content = '';
                if (!$.isEmptyObject(response)) {
                    content = response;
                } else {
                    content = 'No work profile history exists for the user';
                }
                $("#userWorkProfileDiv").html(content);
            }
	});
    }

}

function sendEmailQuickActionClick() {
    $('#sendEmailGroup').empty();
    var selIds = getGridSelRow();
    var selectAll = $('#selectAll').is(':checked');
    if (!selectAll && (!selIds || selIds.length == 0)) {
	alert("Error", "Please select at least one item");
	return;
    }
    $.ezdia.desk.grid.resetGridWidthAndForm();
    hideShowDeskForm('#send-email-form');
    getHtmlBody();
    selectQuickActionLink('sendEmailQALi');
    $('#ez-scroll-nav-pills').scrollingNav('destroy', 'ez-scroll-nav-pills');
    $.ezdia.stickyFormBtns({
        sticky: 'ezdia-bulk-edit-form-btns',
        frm: 'sendemailform'
    });
}

$('#sendEmailBtn').click(function() {
    var activeBtn = $(this);
    activeBtn.button('loading');
    var userNameList = [];
    var selIds = getGridSelRow();
    $.each(selIds, function(i){
	var rowData = $("#grid").jqGrid('getRowData', selIds[i]);
	var id = getDataFromString(rowData['username']);
	if(id) {
	    userNameList.push(parseInt(id))
	}
    });

    var mailData = $('#sendemailform').serialize();
    mailData += "&accountName="+$("#accountName").val();
    mailData += "&role="+$("#role").val();
    mailData += "&ids="+JSON.stringify(userNameList);
    $.ajax({
        type: "POST",
        url: 'Sendmail.htm',
        datatype: 'json',
        data: mailData,
        success: function(response) {
            if (response.success) {
                $("#grid").trigger("reloadGrid");
                $('#footer_center').removeClass('ui-state-disabled');
                hideShowDeskForm();
                $('#selectAll').prop('checked', false);
                selectAllClick();
            }
	    var obj = {
		response: response.msg,
		success: response.success
	    };

	    successErrorDialog(obj);
	},
	error: function(response) {
	    var obj = {
		response: response,
		success: false
	    };
	    successErrorDialog(obj);
	}
    }).always(function () {
      activeBtn.button('reset')
    });
});

function changePasswordQAClick() {
    var selIds = getGridSelRow();
    var selectAll = $('#selectAll').is(':checked');
    if (!selectAll && (!selIds || selIds.length == 0)) {
	alert("Error", "Please select at least one item");
	return;
    }

    resetChangePwdForm();
    $.ezdia.desk.grid.resetGridWidthAndForm();
    hideShowDeskForm('#change-pwd-form');
    selectQuickActionLink('changePwdQALi');

    var validObj = {rules: {
		password: {
		    required: true
		},
		confirmpassword: {
		    required: true,
		    equalTo: "#password"
		}
	    },
	    messages: {
		password: {
		    required: "Please enter your password"
		},
		confirmpassword: {
		    required: "Please Confirm your password",
		    equalTo: "Password and Confirm password is not matched"
		}
	    }};
    $.ezdia.validate.destroy("changePwdform");
    $.ezdia.validate.create(validObj, "changePwdform");
}

function resetChangePwdForm() {
    $('#password').val('');
    $('#confirmpassword').val('');
    $('#sendEmail').prop('checked', false);
 }

$('#changePwdBtn').click(function() {
    var activeBtn = $(this);
    activeBtn.button('loading');

    var userIdsList = [];
    var selIds = getGridSelRow();
    $.each(selIds, function(i){
	var rowData = $("#grid").jqGrid('getRowData', selIds[i]);
	var id = getDataFromString(rowData['username']);
	if(id) {
	    userIdsList.push(parseInt(id));
	}
    });

    var data = "password="+$('#password').val();
    data += "&confirmpassword="+$('#confirmpassword').val();
    data += "&sendEmail="+$('#sendEmail').is(':checked');
    data += "&userIds="+JSON.stringify(userIdsList);

    var valid = $('#changePwdform').valid();
    if (!valid) {
        activeBtn.button('reset');
        return false;
    }
    $.ajax({
        type: "POST",
        url: 'ChangePwdByAdmin.htm',
        datatype: 'json',
        data: data,
        success: function(response) {
	    var obj = {
		response: response.msg,
		success: response.success
	    };

	    successErrorDialog(obj);
	},
	error: function(response) {
	    var obj = {
		response: response,
		success: false
	    };
	    successErrorDialog(obj);
	}
    }).always(function () {
      activeBtn.button('reset');
    });
});

function copyOrgUsersQAClick() {
    var selIds = getGridSelRow();
    var selectAll = $('#selectAll').is(':checked');
    if (selectAll) {
        selIds = getAllItemIds();
    }

    if (!selectAll && (!selIds || selIds.length == 0)) {
	alert("Error", "Please select an item");
	return;
    }
    $('#orgName').val('');
    $('#newUserEmail').prop('checked', false);
    hideShowDeskForm('#copy-users-form');
    selectQuickActionLink('copyUsersQALi');

    var validObj = {rules: {
		orgName: {
		    required: true
		}
	    },
	    messages: {
		orgName: {
		    required: "Please provide organization name."
		}
	    }};
    $.ezdia.validate.destroy("copyOrgUesrsform");
    $.ezdia.validate.create(validObj, "copyOrgUesrsform");
}

 $('#copyOrgUsersBtn').click(function() {
    var activeBtn = $(this);
    activeBtn.button('loading');

    var selIds = getGridSelRow();
    var selectAll = $('#selectAll').is(':checked');
    if (selectAll) {
        selIds = getAllItemIds();
    }
    var userNameList = [];
    var selIds = getGridSelRow();
    $.each(selIds, function(i){
	var rowData = $("#grid").jqGrid('getRowData', selIds[i]);
	var id = getDataFromString(rowData['username']);
	userNameList.push(parseInt(id));
    });
    var data = "orgName="+$('#orgName').val();
    data += "&username="+JSON.stringify(userNameList);
    data += "&newUserEmail="+$('#newUserEmail').is(':checked');

    var valid = $('#copyOrgUesrsform').valid();
    if (!valid) {
        activeBtn.button('reset');
        return false;
    }
    $.ajax({
        type: "POST",
        url: 'CopyOrgUsers.htm',
        datatype: 'json',
        data: data,
        success: function(response) {
	    var obj = {
		response: response.msg,
		success: response.success
	    };

	    successErrorDialog(obj);
	},
	error: function(response) {
	    var obj = {
		response: response,
		success: false
	    };
	    successErrorDialog(obj);
	}
    }).always(function () {
      activeBtn.button('reset');
    });
});

function showOpenProjectDefRule(id) {
    var data = "assignmentQueueId=" + id;
    $.ajax({
        type: "POST",
        url: "fetchDefaultRule.htm",
        data: data,
        dataType: 'json',
        success: function(response) {
            if (response) {
                populateSearchFromJson('expert', 'pm', response.user);
                openProjDefRuleQAClick();
                var counter = assignmentLimitCounter-1;
                $('#role'+counter).val(response.role);
                $('#accountName'+counter).val(response.accountName);
                $('#defRuleOrderId'+counter).val(response.orderId);
                $('#defRuleProjType'+counter).val(response.projectType);
                $('#defRuleAddCond'+counter).val(response.colValue);
                selectQuickActionLink('openProjDefaultRulebtn');
                advancedSearchClick();
            } else {
                alert("Unable to get open project default rule");
            }
        }
    });
}

function enableDisableDefRule(defRuleId, enable) {
    var data = "assignmentQueueId=" + defRuleId;
        data += "&enableRule="+enable;
    $.ajax({
        type: "POST",
        url: "enableDisableDefRule.htm",
        data: data,
        dataType: 'json',
        success: function(response) {
            $("#statusMsg").html(response);
            $("#statusMsg").dialog({
                modal: true,
                width: '300',
                height: 200,
                title: "Success",
                buttons: {
                    Ok: function() {
                        $(this).dialog("close");
                    }
                }
            });
            if (enable) {
                $("#disableDefRule"+defRuleId).show();
                $("#enableDefRule"+defRuleId).hide();
            } else {
                $("#disableDefRule"+defRuleId).hide();
                $("#enableDefRule"+defRuleId).show();
            }
        },
        error: function(response) {

        }
    });
}

function openProjDefRuleQAClick() {
    if(getSearchQueryString()) {
        resetDefaultRuleRow();
        hideShowDeskForm('#openProjDefRuleform');
    } else {
        alert("Error", "Please provide valid search criteria!!");
    }
}

function addDefaultRuleBtnClick() {
    if (assignmentLimitCounter == 0) {
        var defRuleHeaderDiv = $(document.createElement('div')).attr({"id": 'defRuleRowHeader' + assignmentLimitCounter, "class": "clearfix"});
        var header = '';
        header +="<div class='form-group'><label style='width:250px'>Account Name</label></div>";
        header +="<div class='form-group'><label style='width:180px'>Role</label></div>";
        header +="<div class='form-group'><label style='width:190px'>Order Id</label></div>";
        header +="<div class='form-group'><label style='width:190px'>Project Type</label></div>";
        header +="<div class='form-group'><label style='width:200px'>Additional Condition</label></div>";
        defRuleHeaderDiv.append(header);
    }
    var groupTypeArray = [];
    var defRuleDiv = $(document.createElement('div')).attr({"id": 'defRuleRow' + assignmentLimitCounter, "class": "clearfix"});
    var content = buildDefaultRuleRow(assignmentLimitCounter, groupTypeArray);
    var removeBtn = "<a id='defRuleRemoveBtn" + assignmentLimitCounter + "' onclick='removeBtnForDefRuleClick(" + assignmentLimitCounter + ");' type='button' class='btn btn-default inline-button-spacing-sml'><span id='plusminusbtn' class='glyphicon glyphicon-minus'></span></a> ";
    var addBtn = "<a id='defRuleAddBtn' onclick='addDefaultRuleBtnClick();' type='button' class='btn btn-default inline-button-spacing-sml'><span id='plusminusbtn' class='glyphicon glyphicon-plus'></span></a>";
    $("#defRuleAddBtn").remove();
    defRuleDiv.append(content);
    defRuleDiv.append(removeBtn);
    defRuleDiv.append(addBtn);

    if (assignmentLimitCounter == 0) {
        defRuleHeaderDiv.appendTo("#defaultRuleRowGroup");
    }
    defRuleDiv.appendTo("#defaultRuleRowGroup");
    hideShowRemoveBtn('defRuleRemoveBtn');
    createGroupAutoCompleteElement(groupTypeArray);
    sortAccountName('accountName'+assignmentLimitCounter);
    assignmentLimitCounter++;
}

function buildDefaultRuleRow(counter, groupTypeArray) {
    var content = '';
    var defaultAccName = '';
    var accounts = '';
    var pageParams = $.ezdia.config.pageParams;
    allAccountsStr = pageParams.allAccountsExceptExpertMgt;

    if (!allAccountsStr && ezdia.config.user) {
      allAccountsStr = ezdia.config.user.all_accounts_except_expert_mgt;
    }

    if(allAccountsStr) {
        accounts = allAccountsStr.split(",");
        defaultAccName = accounts[0].split("=")[0];
    }
    if (!defaultAccName) {
        return '';
    }
    content +="<div class='form-group'>";
    content +='<select class="form-control" id="accountName' + counter +'" name="accountName' + counter +'" onchange="getProjTypeAndOrderIdData('+counter+','+false+','+false+');">';
    $.each(accounts, function(id, val) {
        var key = val.split("=")[0].trim();
        var value = val.split("=")[1].trim();
	content +='<option value="'+key+'" '+ (key == defaultAccName ? "selected" : "") +'>'+value+'</option>';
    });
    content +='</select></div>';

    var data = getProjTypeAndOrderIdData(counter,defaultAccName, false);
    var roleValue = data.role;

    content +="<div class='form-group'>";
    content +='<select class="form-control" id="role' + counter +'" name="role' + counter +'" onchange="getProjTypeAndOrderIdData('+counter+','+false+','+true+');">';
    $.each(data.allRoles, function(key, value) {
        content += '<option value="' + key + '" ' + (key == roleValue ? "selected" : "") +'>' + value + '</option>';
    });
    content +='</select>';
    content +='</div>';

    content +="<div class='form-group'>";
    content += buildGroupField('defRuleOrderId'+counter, '', data.order_id, null, groupTypeArray);
    content +="</div>";

    content +="<div class='form-group'>";
    content += buildGroupField('defRuleProjType'+counter, '', data.project_type, null, groupTypeArray);
    content +="</div>";

    content +="<div class='form-group'>";
    content +="<input class='form-control' type='text' id='defRuleAddCond" + counter + "' name='defRuleAddCond" + counter + "'/>";
    content +="</div>";
    return content;
}

function resetDefaultRuleRow() {
    $('#defaultRuleRowGroup').empty();
    assignmentLimitCounter = 0;
    addDefaultRuleBtnClick();
}

function removeBtnForDefRuleClick(counter) {
    $("#defRuleRow" + counter).remove();
    if (assignmentLimitCounter == (counter + 1)) {
        var addBtn = "<a id='defRuleAddBtn' onclick='addDefaultRuleBtnClick();' type='button' class='btn btn-default'><span id='plusminusbtn' class='glyphicon glyphicon-plus'></span></a>";
        var lastDivId = $('[id^="defRuleRow"]').last().attr("id");
        $("#" + lastDivId).append(addBtn);
        assignmentLimitCounter = assignmentLimitCounter - 1;
    }
    hideShowRemoveBtn('defRuleRemoveBtn');
}

function getProjTypeAndOrderIdData(counter,accName, role) {
    var accountName = accName || $('#accountName' + counter).val();

    var ret = [];
    if (!accountName) {
        return ret;
    }
    var data = "&assignment_tool_name=" + accountName;
    if (role) {
        data += "&assignment_role_name=" + $('#role' + counter).val();
    }
    $.ajax({
	type: "POST",
	url: "GetAllGroupFields.htm",
	data: data,
	dataType: 'json',
	async: false,
	success: function(response) {
	    ret = response;
	}
    });
    if (!accName) {
        if (!role) {
            $("#role" + counter).empty();
            var content = '';
            var roleValue = ret.role;
            $.each(ret.allRoles, function(key, value) {
                content += '<option value="' + key + '" ' + (key == roleValue ? "selected" : "") +'>' + value + '</option>';
            });
            $("#role" + counter).append(content);
        }
        var grouptypeArray = [];
        grouptypeArray.push({id: 'defRuleProjType'+counter, key: ret.project_type});
        grouptypeArray.push({id: 'defRuleOrderId'+counter, key: ret.order_id});
        createGroupAutoCompleteElement(grouptypeArray);
    }
    return ret;
}

$("#createOpenProjectDefRuleBtn").click(function() {
    var activeBtn = $(this);
    activeBtn.button('loading');
    var searchString = getSearchQueryString();
    if (searchString) {
        $.ajax({
            type: "POST",
            url: 'AddDefaultRule.htm',
            datatype: 'json',
            data: {
                defaultRule: function() {
                    if (assignmentLimitCounter > 0) {
                        return getDefaultRuleString();
                    } else {
                        return '';
                    }
                },
                assignRule: searchString,
                assignment_tool_name: 'expert',
                assignment_role_name: 'pm'
            },
            success: function(data) {
                $("#statusMsg").html(data);
                $("#statusMsg").dialog({
                    modal: true,
                    width: '300',
                    height: 200,
                    title: "Save Default Rule",
                    buttons: {
                        Ok: function() {
                            $(this).dialog("close");
                        }
                    }
                });
            },
            error: function(data) {
                $("#statusMsg").html(data);
                $("#statusMsg").dialog({
                    modal: true,
                    width: '300',
                    height: 200,
                    title: "Save Default Rule",
                    buttons: {
                        Ok: function() {
                            $(this).dialog("close");
                        }
                    }
                });
            }
        }).always(function () {
            activeBtn.button('reset');
        });
    }
    else {
        alert("Please provide valid search criteria!!");
    }
});

function getDefaultRuleString() {
    var entryObj = new Array();
    for (var count = 0; count < assignmentLimitCounter; count++) {
	var jsonvalue = {};
	var defRuleAccountName = $("#accountName" + count).val();
        if (!defRuleAccountName) {
            continue;
        }

	var defRuleRole = $("#role" + count).val();
	var defRuleOrderId = $("#defRuleOrderId" + count).val();
        var defRuleProjType = $("#defRuleProjType" + count).val();
        var addCond = $("#defRuleAddCond" + count).val();

        if (defRuleAccountName && defRuleRole) {
	    jsonvalue.accountName = defRuleAccountName;
            jsonvalue.role = defRuleRole;
            jsonvalue.projectType = defRuleProjType;
            jsonvalue.orderId = defRuleOrderId;
            jsonvalue.colValue = addCond;
            entryObj.push(jsonvalue);
        }
    }
    return JSON.stringify(entryObj);
}

function addButtonClick() {
    var searchFieldDiv = $(document.createElement('div')).attr({"id": 'searchDiv' + searchCounter, "class": "clearfix"});
    var fields = buildFieldDropDown(searchCounter, null);
    var removeBtn = "<a id='removeBtn" + searchCounter + "' onclick='removeSearchDiv(" + searchCounter + ");' type='button' class='btn btn-default inline-button-spacing-sml'><span id='plusminusbtn' class='glyphicon glyphicon-minus'></span></a> ";
    var addBtn = "<a id='addBtn' onclick='addButtonClick();' type='button' class='btn btn-default inline-button-spacing-sml'><span id='plusminusbtn' class='glyphicon glyphicon-plus'></span></a>";
    $("#addBtn").remove();
    searchFieldDiv.append(fields);
    searchFieldDiv.append(removeBtn);
    searchFieldDiv.append(addBtn);

    searchFieldDiv.appendTo("#SearchFieldGroup");
    hideShowRemoveBtn('removeBtn');
    searchCounter++;
}

function removeSearchDiv(counter) {
    $("#searchDiv" + counter).remove();
    if (searchCounter == (counter + 1)) {
        var addBtn = "<a id='addBtn' onclick='addButtonClick();' type='button' class='btn btn-default'><span id='plusminusbtn' class='glyphicon glyphicon-plus'></span></a>";
        var lastDivId = $('[id^="searchDiv"]').last().attr("id");
        $("#" + lastDivId).append(addBtn);
        searchCounter = searchCounter - 1;
    }
    hideShowRemoveBtn('removeBtn');
}

function advancedSearchClick() {
    var bsrchCnt = (basicSearchFields.length == 0) ? 0 : basicSearchFields.split(",").length;
    if (searchCounter <= bsrchCnt) {
        addButtonClick();
    }
}

function hideShowRemoveBtn(id) {
    var removeBtns = $('[id^="'+id+'"]');
    if (removeBtns.length == 1) {
        removeBtns.hide();
    }
    else {
        removeBtns.show();
    }
}

function buildOperatorDropDown(counter, operatorVal, fieldName, newSearch, fieldVal, lowerVal, upperVal) {
    var serchfieldsObj = $.ezdia.getJsonObject(searchFieldsJson);
    var elem = $('#field' + counter);
    var value = elem.val();
    var column = serchfieldsObj[fieldName || value];
    var type = column ? column.type : getFieldType(fieldName);
    var oldType = elem.data('oldType');

    elem.data('oldType', type);

    if (oldType == 'text' && type == 'text'){
        return false;
    }

    $.ezdia.config.search = $.ezdia.config.search || {};
    $.ezdia.config.search.grouptypeArray= [];

    $("#operator" + counter).parents("[data-row='form-group']").remove();
    $("#fieldVal" + counter).parents("[data-row='form-group']").remove();

    if($("#fieldVal_upper" + counter).length) {
        $("#fieldVal_upper" + counter).parents("[data-row='form-group']").remove();
        $("#fieldVal_lower" + counter).parents("[data-row='form-group']").remove();
    }

    var removeBtnId = $("#removeBtn" + counter);
    var styleDisply = (removeBtnId.is(':visible')) ? '' : 'none';
    removeBtnId.remove();
    var content = '';
    if (fieldName == null) {
        fieldName = $("#field" + counter).val();
    }

    content += "<div class='form-group' data-row='form-group'><select class='form-control' id='operator" + counter + "' onchange='removeFieldValObj(" + counter + ");'>";
    if (type == "status" || type == "singlechoice" || type == "multichoice" || type == "group" || type == "visualstatus") {
        if (type == "multichoice" || type == "singlechoice") {
            content += "<option value='LIKE'" + (('LIKE' == operatorVal) ? "selected" : "") + ">Contains</option>";
            content += "<option value='NL'" + (('NL' == operatorVal) ? "selected" : "") + ">Not Contains</option>";
        }
        content += "<option value='EQ'" + (('EQ' == operatorVal) ? "selected" : "") + ">Equals</option>";
        content += "<option value='NE'" + (('NE' == operatorVal) ? "selected" : "") + ">Not Equals</option>";
        content += "<option value='IE'" + (('IE' == operatorVal) ? "selected" : "") + ">Is Empty</option>";
    }
    else if (type == "line") {
        content += "";
    }
    else {
        content += "<option value='EQ'" + (('EQ' == operatorVal) ? "selected" : "") + ">Equals</option>";
        content += "<option value='NE'" + (('NE' == operatorVal) ? "selected" : "") + ">Does Not Equal</option>";
        content += "<option value='NN'" + (('NN' == operatorVal) ? "selected" : "") + ">Not Empty</option>";
        if (type != "date") {
            content += "<option value='LIKE'" + (('LIKE' == operatorVal) ? "selected" : "") + ">Contains</option>";
            content += "<option value='NL'" + (('NL' == operatorVal) ? "selected" : "") + ">Does Not Contain</option>";
        }
        if (type == "int" || type == "date") {
            content += "<option value='GT'" + (('GT' == operatorVal) ? "selected" : "") + ">Greater Than</option>";
            content += "<option value='LT'" + (('LT' == operatorVal) ? "selected" : "") + ">Less Than</option>";
            content += "<option value='BTW'" + (('BTW' == operatorVal) ? "selected" : "") + ">Between</option>";
        }
        else {
            content += "<option value='IE'" + (('IE' == operatorVal) ? "selected" : "") + ">Is Empty</option>";
        }
    }
    content += "</select></div>";
    content += buildFieldValObject(counter, fieldVal, fieldName, operatorVal, lowerVal, upperVal);
    content += "<a id='removeBtn" + counter + "' style='display:" + styleDisply + "' onclick='removeSearchDiv(" + counter + ");' type='button' class='btn btn-default inline-button-spacing-sml'><span id='plusminusbtn' class='glyphicon glyphicon-minus'></span></a>";

    if (newSearch) {
        $("#field" + counter).parents("[data-row='form-group']").after(content);
        if (type == "date") {
            if (operatorVal == 'BTW') {
                $("#fieldVal_lower" + counter).datepicker({
                    dateFormat: 'yy-mm-dd'
                });
                $("#fieldVal_upper" + counter).datepicker({
                    dateFormat: 'yy-mm-dd'
                });
            } else if (operatorVal != 'NN') {
                $("#fieldVal" + counter).datepicker({
                    dateFormat: 'yy-mm-dd'
                });
            }
        }
        if(!$.isEmptyObject($.ezdia.config.search.grouptypeArray)){
            $.ezdia.typehead.create($.ezdia.config.search.grouptypeArray);
        }
    }
    return content;
}

function buildFieldValObject(counter, fieldVal, fieldName, operator, lower, upper) {
    var content = '';
    var serchfieldsObj = $.ezdia.getJsonObject(searchFieldsJson);
    var column = serchfieldsObj[fieldName];
    if (fieldVal == null) {
        fieldVal = '';
    }
    if (operator == null || (operator != 'NN' && operator != 'IE')) {
        var type = column ? column.type : getFieldType(fieldName);
        var addon = column ? column.addon : getFieldAddon(fieldName);
        if (type == "status") {
            if (statuses) {
                content += "<div class='form-group' data-row='form-group'><select class='form-control' id='fieldVal" + counter + "'>";
                content += "<option value=''></option>";
                $.each(statuses, function(id, val) {
                    val = val.replace(" ", "");
                    content += "<option value='" + val + "' " + ((val == fieldVal) ? "selected" : "") + " >" + val + "</option>";
                });
                content += "</select></div>";
            }
        }
        else if (type == "singlechoice" || type == "dropdown" || type == "visualstatus" || type == "multichoice") {
            column.edittype = column.type;
            column.id = "fieldVal" + counter;
            $.ezdia.getFieldsConfig(column);

            content += "<div class='form-group' data-row='form-group'>";
            content += $.ezdia.inputs.singlechoice({column: column, value: fieldVal});
            content += "</select></div>";
        }
//        else if (type == "multichoice") {
//            column.edittype = column.type;
//            column.id = "fieldVal" + counter;
//            $.ezdia.getFieldsConfig(column);
//
//            content += "<div class='form-group' data-row='form-group'>";
//            content += $.ezdia.inputs.multichoice({column: column, value: fieldVal});
//            content += "</select></div>";
//        }
        else if (type == "role" || type == "group") {
            var config = serchfieldsObj[fieldName] ? serchfieldsObj[fieldName].config : getFieldConfig(fieldName);
            var roleObj = {
                name: "fieldVal" + counter,
                edittype: type,
                config: config,
                editable: true,
                metadata: addon
            };

            config = $.ezdia.getFieldsConfig(roleObj);
            content += "<div class='form-group' data-row='form-group'>";

            if (type == "group" || (config && config.url)) {
                $.ezdia.typehead.init($.ezdia.config.search.grouptypeArray, {column: ($.extend({}, roleObj, {isSearch: true}))});
                content += $.ezdia.inputs.textboxs({column: roleObj, value: fieldVal});
            } else {
                content += "<input class='form-control' id='fieldVal" + counter + "' type='text' name='fieldVal" + counter + "' value='" + fieldVal + "'/>";
            }
            content += "</div>";
        }
        else if (type == "line") {
            content += "<div style='height:1px;background:#717171;border-bottom:1px solid #313030;'></div>";
        }
        else {
            if (operator && operator == 'BTW') {
                if (lower == null) {
                    lower = '';
                }
                if (upper == null) {
                    upper = '';
                }
                content += "<div data-row='form-group'>";
                content += "<div class='form-group'><input class='form-control' placeholder='Lower' id='fieldVal_lower" + counter + "' type='text' title='Lower' name='fieldVal_lower" + counter + "' value='" + lower + "'/></div>";
                content += "<div class='form-group'><input class='form-control' placeholder='Upper' id='fieldVal_upper" + counter + "' type='text' title='Upper' name='fieldVal_upper" + counter + "' value='" + upper + "'/></div>";
                content += "</div>";
            } else {
                content += "<div class='form-group' data-row='form-group'><input class='form-control' id='fieldVal" + counter + "' type='text' name='fieldVal" + counter + "' value='" + fieldVal + "'/></div>";
            }
        }
    }
    return content;
}

function removeFieldValObj(counter) {
    var changeOperators = {'BTW':true,'NN':true, 'IE': true};
    var elem = $("#operator" + counter);
    var operator = elem.val();
    var old = elem.data('old');
    var serchfieldsObj = $.ezdia.getJsonObject(searchFieldsJson);

    elem.data('old', operator);

    if (!changeOperators[old] && !changeOperators[operator]) {
        return false;
    }

    $("#fieldVal" + counter).parents("[data-row='form-group']").remove();
    $("#fieldVal_upper" + counter).parents("[data-row='form-group']").remove();
    $("#fieldVal_lower" + counter).parents("[data-row='form-group']").remove();

    if (operator && operator == 'BTW') {
        var fieldName = $("#field" + counter).val();
        var upper = $("#fieldVal_upper" + counter).val();
        var lower = $("#fieldVal_lower" + counter).val();
        var content = buildFieldValObject(counter, null, fieldName, operator, lower, upper);
        $("#removeBtn" + counter).before(content);
        if (serchfieldsObj[fieldName] && serchfieldsObj[fieldName].type == 'date') {
            $("#fieldVal_lower" + counter).datepicker({
                dateFormat: 'yy-mm-dd'
            });
            $("#fieldVal_upper" + counter).datepicker({
                dateFormat: 'yy-mm-dd'
            });
        }
    }
    else if (!$("#fieldVal" + counter).length) {
        $.ezdia.config.search.grouptypeArray = [];
        var fieldName = $("#field" + counter).val();
        var content = buildFieldValObject(counter, null, fieldName, operator, null, null);
        $("#removeBtn" + counter).before(content);
        if (serchfieldsObj[fieldName] && serchfieldsObj[fieldName].type == 'date') {
            $("#fieldVal" + counter).datepicker({
                dateFormat: 'yy-mm-dd'
            });
        }

        if(!$.isEmptyObject($.ezdia.config.search.grouptypeArray)){
            $.ezdia.typehead.create($.ezdia.config.search.grouptypeArray);
        }
    }
}

function populateSearchFromJson(accountName, role, searchJson) {
    $("#accountName").val(accountName);
    $("#role").val(role);

    var searchOperand;
    $("#SearchFieldGroup").html('');
    if (searchJson != '') {
        var queryObjArr = eval('(' + (searchJson || "{}") + ')');
        var bsrchFields = basicSearchFields.split(", ");
        var counter = (basicSearchFields.length == 0) ? 0 : bsrchFields.length;
        var searchfieldsObj = eval('(' + searchFieldsJson + ')');
        $.each(queryObjArr, function(fieldName, queryObj) {
            var searchEleName = queryObj.name;
            var searchEleVal = queryObj.value;
            if (searchEleName == 'state') {
                var statusField = submitFields;
                searchEleName = statusField;
            }
            var validField = getFieldType(searchEleName);
            if (searchfieldsObj[searchEleName] || validField) {
                var operatorVal = queryObj.operator;
                var lowerVal = queryObj.lower;
                var upperVal = queryObj.upper;
                var operand = queryObj.operand;
                var type = searchfieldsObj[searchEleName]?searchfieldsObj[searchEleName].type:getFieldType(searchEleName);
                var searchFieldDiv = $(document.createElement('div')).attr({"id": 'searchDiv' + counter, "class": "clearfix"});
                var fields = buildFieldDropDown(counter, searchEleName);
                searchFieldDiv.append(fields);
                var operators = buildOperatorDropDown(counter, operatorVal, searchEleName, false, searchEleVal, lowerVal, upperVal);
                searchFieldDiv.append(operators);
                searchFieldDiv.appendTo("#SearchFieldGroup");
                if (type == "date") {
                    if (operatorVal == 'BTW') {
                        $("#fieldVal_lower" + counter).datepicker({
                            dateFormat: 'yy-mm-dd'
                        });
                        $("#fieldVal_upper" + counter).datepicker({
                            dateFormat: 'yy-mm-dd'
                        });
                    } else if (operatorVal != 'NN') {
                        $("#fieldVal" + counter).datepicker({
                            dateFormat: 'yy-mm-dd'
                        });
                    }
                }
                searchOperand = operand ? operand : 'and';
                counter++;
            }
            else {
                var index = bsrchFields.indexOf(searchEleName);
                if (index != -1) {
                    $("#fieldVal" + index).val(searchEleVal);
                }
            }
        });
        var addBtn = "<a id='addBtn' onclick='addButtonClick();' type='button' class='btn btn-default'><span id='plusminusbtn' class='glyphicon glyphicon-plus'></span></a>";
        $("#searchDiv" + (counter - 1)).append(addBtn);
        if (searchOperand && searchOperand !== "")
            $("#srchOperand").val(searchOperand);
        hideShowRemoveBtn('removeBtn');
    }
    else {
        addButtonClick();
        counter++;
    }
    searchCounter = counter;
    if($("#pageTemplateName").val() === 'desk'){
       getGridModel(true);
    }
    else{
        $("#genericSearchBtn").trigger('click');
    }
    if(!$('#SearchFieldGroup').html()){
        $('#demo').removeClass('in').css('height','0px');
        $('#advancedSearchLink').addClass('collapsed');
    }
    if(!$.isEmptyObject($.ezdia.config.search.grouptypeArray)){
        $.ezdia.typehead.create($.ezdia.config.search.grouptypeArray);
    }
}

function basicSearchChange(value, counter) {
    if(document.getElementById('searchBtn') != null){
        $("#searchBtn").trigger('click');
    }
    else{
        $("#genericSearchBtn").trigger('click');
    }
}

function getSearchQueryString(allIds) {
   
    return $('#searchFrm').search('getQueryString');

}

function getItemDetail(property, id) {
    $.ajax({
        url: 'EditAItem.htm',
        data: 'accountName=' + $('#accountName').val() + '&role=' + $("#role").val() + '&itemProperty=' + property + '&itemId=' + id,
        type: "GET",
        datatype: 'json',
        success: function(response) {
            renderItemOnRowSelect(response, id);
        }
    });
}

function openHtmlPastePanel(id) {
    var activeEditor = tinymce.get(id);
    activeEditor.focus();
    activeEditor.plugins.codemagic._openPasteWindow(activeEditor);
}

function sortLiList(className) {
    $('.' + className).each(function() {
        var listBox = $(this);
        listBox.append(listBox.find('li').sort(function(a, b) {
            return (
                    a = $(a).text(),
                    b = $(b).text(),
                    a == b ? 0 : (a < b ? -1 : 1)
                    );
        }));
    });
}

/*Remoev div added during creating grid data using formatter funtion and Return string value. */
function getDataFromString(string) {
    var value = string;
    var divPattern = /<div.*class=.col-max-height.*<\/div>/;
    try {
        if($(string).hasClass('col-max-height') && string.match(divPattern)) {
            string = string.replace(/<div class="col-max-height.*?>/,'');
            value = string.substring(0, string.lastIndexOf("</div>"));
        }
    }
    catch (err) {
        console.log('getDataFromString() -- error in data format')
    }
    
    return value;
}

function callIdeaCheckBoxHandler() {
    $('[id^=idea-cb]').click(function() {
        var ideaVal = 'A' + this.defaultValue + 'A';
        $("#SubmitOrdBtn").removeAttr("disabled");
        if (topics) {
            if (this.checked) {
                topics += "," + ideaVal + "";
                itemCount++;
            }
            else {
                topics = topics.replace(ideaVal, "");
                itemCount--;
            }
        }
        else {
            topics = ideaVal;
            itemCount++;
        }
        $('#totalItemToCreate').html(itemCount);
        if (itemCount == 0) {
            $("#SubmitOrdBtn").prop('disabled', true);
        }
    });
}
/*
 * End Tinymce Add Comment
 */

/*
 * Auto local save data.
 */
//var hasSupportsLocalStorage = false;
var currentAccountKey;
var currentIdFormValues = {};
var localStorageObj = {};

/*
 * Get date and time
 */
function getCurrentDateTime() {
    var d = new Date();
    var monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
    var hours = d.getHours();
    var min = d.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    var time = ("0" + hours).slice(-2) + ':' + ("0" + min).slice(-2) + ' ' + ampm;
    var timestamp = monthNames[d.getMonth()] + ' ' + ("0" + d.getDate()).slice(-2) + ', ' + d.getFullYear() + ' at ' + time;
    return timestamp;
}
/*
 * scroll page to id
 */
function scrollToId(id) {
    var scrollTop = 0;
    var animated_wrapper = $('.animated-wrapper');
    var topPad = 0;

    if (animated_wrapper.length) {
        topPad = animated_wrapper.css('paddingTop') || 0;
        topPad = parseInt(topPad);
    }

    if (id instanceof jQuery) {
        scrollTop = id.offset().top;
    } else {
        scrollTop = $('#' + id).offset().top;
    }
    $('html, body').animate({
        scrollTop: scrollTop - topPad
    }, 500);
}

function convertHtmlToPlainText(id) {
    var ed = tinyMCE.get(id);
    var content = ed.getContent();
    content = content.replace(/<br\s*\/?>/mg, "\\n")
            .replace(/<p>/mg, "")
            .replace(/<\/p>/mg, "\\n");
    return content;
}

function convertPlainTextToHtml(content) {
    content = content.replace(/\\n/ig, "<br />");
    return content;
}

function setSliderValue(key, value, id) {

    if(id){
        id.trigger('change');
    }

    $('#' + key + '_slider_value').text(value);
    var parentEl = $('#' + key + '_slider');
    var textId = $('#' + key);
    var isColor = textId.attr('data-color');
    if (value && isColor == 'true') {
        if (value <= 3) {
            parentEl.switchClass({add: 'writer-bad', remove: ['writer-average', 'writer-good']});
        } else if (value <= 6) {
            parentEl.switchClass({add: 'writer-average', remove: ['writer-bad', 'writer-good']});
        } else {
            parentEl.switchClass({add: 'writer-good', remove: ['writer-bad', 'writer-average']});
        }
    }
}

function hasCustomeColor(value) {
    var c;
    $.each(pieColorPalette, function(i, obj) {
        if (obj.legend == value) {
            c = obj.color;
            return false;
        }
    });
    return c;
}

function getQuickActionData(selIds){
    var dataObj = [];
    var selectAll = $('#selectAll').is(':checked');
    if (selectAll) {
        selIds = getAllItemIds();
        selIds = selIds.split(',');
    }
    $.each(selIds, function (i, id){
        dataObj.push($("#grid").jqGrid('getRowData', id));
    });
    return dataObj;
}

function getQuickFieldValue(quickData, field, fieldType){
    var firstValue = '';
    var quickLength = quickData.length;
    if(quickLength>0 && quickData[0].hasOwnProperty(field)){
        firstValue = getColDataString(fieldType, quickData[0][field]);
        if (quickLength >= 1) {
            for( var i = 1; i < quickLength; i++) {
                if(!firstValue || firstValue !== getColDataString(fieldType, quickData[i][field])){
                    firstValue = '';
                    break;
                }
            }
        }
    }
    return firstValue;
}

function checkItemMetaInfo(query) {    

    if($.isEmptyObject(query)){
        return query;
    }
    
    var ids = [];
    var selectelem = $('#selectAll');
    var selectAll = selectelem.length ? selectelem.is(':checked') : true;
    if(!query.shareDashboard) {
        ids = getGridSelRow();
	if (!selectAll && (!ids || ids.length === 0)) {
	    return false;
	}
    }

    var result = "false";
    var data = "&accountName=" + $.ezdia.config.pageParams.account;
    data += "&role=" + $.ezdia.config.pageParams.role;
    data += "&taskId=" +ids;
    data += "&action=" + JSON.stringify(query);

    $.ajax({
        type: "POST",
        url: "checkItemMetaInfo.htm",
        data: data,
        dataType: 'json',
        async: false,
        success: function(response) {
            result = response;
        },
        error: function() {
            result = {};
        }
    });
    return result;
}

function findworkValidate() {
    var paySelect = $('[name="payment_mode"]');
    var neftSelect = $("[name='payment_mode'] option:contains('NEFT')").attr("disabled", "disabled").hide();
    var neftParent = $('#bank_acc_holder_name-main,#bank_branch_name-main,#bank_ifsc_code-main,#bank_account_no-main,#pan-main,#pan_upload-main,#aadhaar-main,#aadhaar_upload-main').hide();
    var neft = $('#bank_acc_holder_name,#bank_branch_name,#bank_ifsc_code,#bank_account_no,#pan,#pan_upload,#aadhaar,#aadhaar_upload').attr('disabled', 'disabled');
    var paypalParent = $('#paypal-main');
    var paypal = $('#paypal');

    paySelect.find('option:first-child').remove();
    $('#country').change(function() {
        var value = $.trim((this.value).toLowerCase());
        if (value == 'india') {
            neftSelect.removeAttr('disabled').show();
        } else {
            neftSelect.attr("disabled", "disabled").hide();
            neftParent.hide();
            neft.attr('disabled', 'disabled').val('');

            paySelect.prop('selectedIndex', '0');
            paypalParent.show();
            paypal.removeAttr('disabled');
        }
    });

    $('[name="payment_mode"]').change(function() {
        var self = $(this);
        var value = self.val();
        if (value == 'Paypal') {
            if (neftParent.is(':visible')) {
                neftParent.hide();
                neft.attr('disabled', 'disabled');
            }
            paypalParent.show();
            paypal.removeAttr('disabled');
        } else if (value == 'NEFT') {
            if (paypalParent.is(':visible')) {
                paypalParent.hide();
                paypal.attr('disabled', 'disabled');
            }
            neftParent.show();
            neft.removeAttr('disabled');
        } else {
            paypalParent.show();
            paypal.removeAttr('disabled');
            neftParent.hide();
            neft.attr('disabled', 'disabled');
        }
    });
}

function emailShareItemLinks(links, selIds) {
    var data = "shareEmail=" + $('#shareItemEmail').val();
       data += "&shareLinks=" + links;
       data += "&roleName=" + $('#role').val();
       data += "&accountName=" + $('#accountName').val();
       data += "&taskId=" + selIds;
    $.ajax({
        type: "POST",
        url: "emailShareItemLinks.htm",
        data: data,
        dataType: 'json',
        success: function(response) {
            $("#shareLinkMsg").html(response);
        }
    });
}

function createSowTypeHead(inputId, urlStr) {
    var id = inputId || 'sow_id';
    var url = urlStr || 'SowList.htm';
    var idObj = $('#'+id);
    idObj.typeahead({
        hint: true,
        highlight: true,
        minLength: 2
    }, {
        name: id,
        displayKey: '',
        source: substringMatcher(url, 'SOW')
    }).on('typeahead:selected', function(e, selection) {
        if (selection.value === 'Add New SOW') {
            idObj.typeahead('val', selection.label);
            $.ajax({
                type: "POST",
                url: 'CreateSow.htm?action=new',
                dataType: 'text',
                success: function(response) {
                    createAddContentWidget(response, 'sow_id-main');
                },
                error: function(response) {
                    $("#message").html(response);
                }
            });
            return false;
        } else {
            setProductType(selection.value, 'product_type-main');
        }
    });
}

function setProductType(value, id) {
    $.ajax({
        type: "POST",
        url: 'FetchSOWProducts.htm',
        dataType: 'json',
        data: {
            sow: value
        },
        success: function(response) {
            currentSOWProducts = response;
            var content = '<label class="control-label" for="product_type">Product Type</label>'
            content += '<div class="inputs">'
            content += '<select class="form-control input-xlarge" id="product_type" name="product_type">'
            $.each(response, function(key, val) {
                var selected = ''
                var product = $("#product_type").val();
                if (val.key === product)
                    selected = 'selected';
                content += '<option value="' + val.key + '" "' + selected + '">' + val.key + '</option>'
            });
            content += ' </select>'
            content += '</div>'
            $("#"+id).html(content);
        },
        error: function(response) {
            $("#message").html(response);
        }
    });
}

function resetQuickAction(self){
    var quickForm = self.closest('form');
    quickForm.find('input:not([type="button"]):not([readonly]), select, textarea').val('');
    quickForm.find('[multiple="multiple"]').multiSelect('refresh');
}

function successErrorDialog(obj){
    var title = (obj.success === true) ? 'Success' : 'Error';
    var wrapper = document.getElementById('message');

    if(!wrapper) {
        var divEl = $('<div>', {
            id: 'message'
        });
        $('body').append(divEl);
    }
    wrapper = $("#message");

    wrapper.html(obj.response);
    wrapper.dialog({
        modal: true,
        title: title,
        width: 'auto',
        height: 'auto',
        buttons: [{
            text: 'Dismiss',
            class: "btn-link",
            click: function () {
                $(this).dialog("close");
                if(obj.success === true && obj.gridid){
                    $(obj.gridid).trigger('reloadGrid');
                }
                else if (obj.success === true && obj.url) {
                    window.location.href = obj.url;
                } else if (obj.session){
                    refreshSession();
                }                
            }
        }]
    });
}

function testConfigClick() {
    $.ezdia.integration.testIntegration(true);
}

function publishData(sites) {
    var data = '';
    var acc = $("#accountName");
    var accountName = acc.length ? acc.val() : '';
    if(sites && sites.length==1) {
	//var value = sites[0].replace(/\s/g, '_');
        var value = $.ezdia.sanitizer.specialChar(sites[0]);
	data = $('#createNewSite').serialize();
	if(!data) {
	    data = $('#editSite').serialize();
	}
	data += '&userName='+ encodeURIComponent($("#user_name_"+value).val());
	data += '&passwd='+ encodeURIComponent($("#passwd_"+value).val());
        data += '&site='+value;
        data += '&accountName='+ accountName;

	$.ajax({
	    type: "POST",
	    url: 'TestSiteConnection.htm',
	    data: data,
	    dataType: 'json',
	    success: function(response) {
		testSiteConnection = true;
//		$("#message").html(response);

		if(response.aem_components) {
		    aemFieldList = response.aem_components;
		}
		var obj = {
		    response: response.msg,
		    success: response.success,
		    url: ''
		};
		successErrorDialog(obj);
	    },
	    error: function(response) {
//		$("#message").html(response);
		var obj = {
		    response: response,
		    success: false,
		    url: ''
		};
		successErrorDialog(obj);
	    }
	});

    } else {
	$.each(sites, function(i, val) {
	    if (val) {
		//var value = val.replace(/\s/g, '_');
                var value = $.ezdia.sanitizer.specialChar(val);
		data = $('#bulkEditFrm').serialize();
		data += '&userName='+ encodeURIComponent($("#user_name_"+value).val());
		data += '&passwd='+ encodeURIComponent($("#passwd_"+value).val());
		data += '&site='+val;
		data += '&accountName='+accountName;

		$.ajax({
		    type: "POST",
		    url: 'TestSiteConnection.htm',
		    data: data,
		    dataType: 'json',
		    success: function(response) {
			testSiteConnection = true;
//			$("#message").html(response);
			var obj = {
			    response: response.msg,
			    success: response.success,
			    url: ''
			};
			successErrorDialog(obj);
		    },
		    error: function(response) {
//			$("#message").html(response);
			var obj = {
			    response: response,
			    success: false,
			    url: ''
			};
			successErrorDialog(obj);
		    }
		});
	    }
	});
    }
}

function createAEMComponentFieldMap(id){
    var html = '';
    var item = $('#selectItem').val();
    var appendAccCount = '';
    var accName = '';
    var accId = '';
    if(id > -1) {
	appendAccCount = '_'+id;
	accName = $('#create_site_account_name_'+id+' option:selected').text();
	accId = $('#create_site_account_name_'+id+' option:selected').val();
    }
    $.each(siteTypes, function(key,value) {
	if(key == item) {
	    if(value.fields) {

		var siteFields = JSON.parse(value.fields);
		var count = siteFields.remote_fields.length;
		$.each(aemFieldList, function(rk, rv) {
		    html += '<div class="remote-inputs" id="remote_fields_' + count + '">'
			    + '<label class="control-label" id="' + rk + '">' + rv + '</label>'
			    + '<select class="form-control input-small"  id="' + rk + appendAccCount + '" name="' + rk + appendAccCount + '">'
			    + '<option value></option>';
		    html += getEzdiaFieldMapValue(accId, rv);
		    html += '</select></div>';
		});
	    }
	}
    });

    return html;
}

function getSiteName() {
    var data = "accountName=" + $('#accountName').val();
    $.ajax({
        type: "POST",
        url: 'GetSiteName.htm',
	async: false,
        dataType: 'json',
	data: data,
        success: function(response) {
	    if(response.success === true) {
		data = response.siteType;
	    }
	    else {
		$("#message").html(response.msg);
		data='';
	    }
        },
        error: function(response) {
            $("#message").html(response.msg);
	    data='';
        }
    });

    return data;
}

function setSiteType(siteVal) {
    var selectedVal = '';
    if(siteVal) {
	selectedVal = $('#site_type').val();
    }
    var html = '<label class="control-label" for="site_type">Site Type<span class="required">*</span></label>'
	    + '<div class="inputs" id="site_type">'
	    + '<select class="form-control input-xlarge input-inline"  name="site_type" id="selectItem">'
	    + '<option value></option>';

    $.each(siteTypes, function(key,value){
	html += '<option value="'+key+'"'+ ((value.label == selectedVal) ? "selected" : "")+'>';
	html += value.label;
	html += '</option>';
    });
    html += '</div>';

    $("#site_type-main").removeClass('has-feedback').html(html);
}

function siteCheckBoxClicked() {
$('#site_acc_mapping_checkbox').click(function() {
    var checkbox = $(this);
    if (checkbox.prop("checked")) {
	hideFieldMap();
	isSameMapAcc = true;
    } else {
	showFieldMap();
	isSameMapAcc = false;
    }
});
}

function showFieldMap() {
    $('#field_acc_name_0').show();
    for(var counter = 1; counter<=acc_count; counter++) {
	$('#site_field_map_'+counter).show();
    }
}

function hideFieldMap() {
    $('#field_acc_name_0').hide();
    for(var counter = 1; counter<=acc_count; counter++) {
	$('#site_field_map_'+counter).hide();
    }
}

function accountNameChange(id) {
    if(id > -1) {
	// adjust the field map
	var html = createFieldMap(id);
	$('#site_field_map_'+id).replaceWith(html);
    }
}

function addAccountRow() {
    acc_count = acc_count + 1;
    var html = '<div class="create-site-add-account input-group-site" id="site_account_name_' + acc_count + '">'
	    + '<select class="form-control input-xlarge input-inline"  id="create_site_account_name_'+acc_count+'" name="site_account_name_' + acc_count + '" onchange="accountNameChange(' + acc_count + ')">';

    $.each(allAccounts, function(key, value){
	html += '<option value="'+key+'">';
	html += value;
	html += '</option>';
    });

    html += ' </select><a class="btn btn-primary inline-button-spacing" onclick=addAccountRow(); href="javascript:void(0);">+</a><a class="btn btn-primary inline-button-spacing" onclick=deleteAccountRow(' + acc_count + '); href="javascript:void(0);">-</a>';
    html += '</div>';

    $("#site_account_name-main .inputs").append(html);
    sortAccountName('create_site_account_name_'+acc_count);
    // adjust the field map too
    html = createFieldMap(acc_count);

    $("#site_field_map-main .inputs").append(html);
}

function deleteAccountRow(id) {

    $("#site_account_name_" + id).remove();
    // adjust the field map too
    $("#site_field_map_"+id).remove();

    var el = $("#site_account_name-main .input-group-site");
    var count = el.length;
    var elId;
    if(count == 1) {
	elId = el.attr("id");
	if($("#"+elId).find(".btn-plus").length == 0) {
	    $("#"+elId+" input").after('<a class="btn btn-primary inline-button-spacing btn-plus" onclick=addAccountRow(); href="javascript:void(0);">+</a>');
	}
    } else if(count == 0) {
	setAccounts();
    }
}

function setAccounts() {
    var html = '<label class="control-label">Project Type*</label>'
	    + '<div class="inputs" id="site_account_name">'
	    + '<div class="input-group-site" >'
	    + '<select class="form-control input-xlarge input-inline"  id="create_site_account_name_0" name="site_account_name_0" onchange="accountNameChange(0)">';
    html += '<option value=""></option>';
    $.each(allAccounts, function(key, value){
	html += '<option value="'+key+'">';
	html += value;
	html += '</option>';
    });

    html += ' </select><a class="btn btn-primary inline-button-spacing btn-plus" onclick=addAccountRow(); href="javascript:void(0);">+</a>';
    html += '</div></div>';

    $("#site_account_name-main").removeClass('has-feedback').html(html);
    sortAccountName('create_site_account_name_0');
    // adjust the field map too
    html = '<label class="control-label">Field Map</label>'
	    + '<div class="inputs" id="site_field_map">';
    html += createFieldMap(acc_count);
    html += '</div>';
    if(changeLook){
	$("#site_field_map-main").removeClass('has-feedback').html(html);
    }
}

function getEzdiaFieldMapValue(accId, value) {
    var html = '';
    $.each(availableFields, function(ak, av) {
	$.each(av, function(i) {
	    if(ak == accId) {
		html += '<option value="'+av[i].name+'"'+ ((value == av[i].name) ? "selected" : "")+'>';
		html += av[i].label;
		html += '</option>';
	    }
	});
    });
    return html;
}

function createFieldMap(id) {
    var html = '';
    var item = $('#selectItem').val();
    var appendAccCount = '';
    var accName = '';
    var accId = '';
    if(id > -1) {
	appendAccCount = '_'+id;
	accName = $('#create_site_account_name_'+id+' option:selected').text();
	accId = $('#create_site_account_name_'+id+' option:selected').val();
    }
    $.each(siteTypes, function(key,value) {
	if(key == item) {
	    if(value.fields) {
		html += '<div class="sub-inputs" id="site_field_map'+appendAccCount+'">';
		html += '<label class="sub-control-label" id="field_acc_name'+appendAccCount+'">'+accName+'</label>';
		html += '<div class="sub-sub-inputs" id="site_field_map-sub">';
		var siteFields = JSON.parse(value.fields);
		$.each(siteFields.remote_fields, function(rk, rv) {
		    html += '<div class="remote-inputs" id="remote_fields_' + rk + '">'
			    + '<label class="control-label" id="' + rv.name + '">' + rv.label + '</label>'
			    + '<select class="form-control input-small"  id="' + rv.name + appendAccCount + '" name="' + rv.name + appendAccCount + '">'
			    + '<option value></option>';
		    html += getEzdiaFieldMapValue(accId, rv.suggested_map);
		    html += '</select></div>';
		});
		html += createAEMComponentFieldMap(id);
		html += '</div></div>';
		changeLook = true;
	    }
	}
    });
    return html;
}

function getSiteMapCheckBox() {
    var html = '';
    html += '<label class="control-label" for="site_acc_mapping_checkbox"></label>'
	    + '<div class="inputs">'
	    + '<div class="checkbox">'
	    + '<label><input id="site_acc_mapping_checkbox" name="site_acc_mapping_checkbox" type="checkbox" value="Use same mapping for all accounts">'
	    + 'Use same mapping for all accounts'
	    + '</label>'
	    + '</div>'
	    + '</div>';

    return html;
}

function changeFieldsLabels(data) {
    var configObj = getCustomConfig('change_label');
    var list = {};

    if (configObj) {
        $.each(configObj, function(index, obj) {
            $.each(obj, function(key, value) {
                var match = false;
                if (value.NE) {
                    match = ($.inArray($(data[key]).html(), value.NE) === -1);
                } else if (value.EQ) {
                    match = ($.inArray($(data[key]).html(), value.EQ) !== -1);
                }
                if (match) {
                     list[obj['field']] = obj['newLabel'];
                }
                return false;
            });
        });
    }
    return list;
}

function hideShowDeskForm(display){
    $('.mceListBoxMenu, .mceSplitButtonMenu').remove();
    cleanTinymceWarningError();
    removeTimer();
    $('#updateFrm').find('[data-container="error"]').hide();
    $("#bulkEditFrm, #updateBtnContainer, #assignment-limit-form, #send-email-form, #change-pwd-form, #copy-users-form, #openProjDefRuleform, #ez-ui-form-configuration-fields-wrapper, #ez-ui-form-configuration-fields-add-btn, #ez-desk-form-group-collapse-link-wrapper, #ez-form-configuration-btn, #ez-edit-store-form, #ez-desk-form-actions-wrapper, #checkout-items-form").hide();
    $("#content, #edCommentForm, #allOpenProjectsDiv, #ez-ui-form-configuration-fields, #assignmentTimeLimitDiv, #ez-desk-share-item-link-wrapper, #userWorkProfileDiv, #editAAccount, #editAOrder, #ez-sys-form-tabs").empty('');
    $('#formFieldEditContent').off('click');
    $('#ez-desk-form-actions-wrapper').removeClass("ez-scroll-nav-pills-form-sticky");
    $('#ez-page-top-navbar').show();

    if(display) {
        $(display).show();
    }
}

function selectQuickActionLink(el) {
    $('#qaction_links > .active').removeClass('active');
    if (el) {
        $('#'+el).addClass('active');
    }
}

function createMobilePreview(e){
    var elem = $(e.target);
    var type = elem.data('preview');
    var url = elem.data('url');
    var template = $.ezdia.template.get('share-preview-moblie');
    var context = '';
    var wrapper = document.getElementById('ez-preview-mobile-wrapper');

    if(!wrapper){
        $('body').append($('<div>', {
            id: 'ez-preview-mobile-wrapper',
            class: 'ez-preview-mobile-wrapper'
        }));
    }
    wrapper = $('#ez-preview-mobile-wrapper').show();

    $('body').css('overflow', 'hidden');

    wrapper.html(template({
        type: type,
        src: url
    }));

    var closeBtn = $('#ez-mobile-preview-close');

    $('body').on('keyup.ez-share-mobile', function(e) {
        if (e.keyCode == 27) {
            closeBtn.trigger('click');
        }
    });

    closeBtn.on('click.ez-share-mobile', function(){
        $('body').off('.ez-share-mobile').css('overflow', '');
        wrapper.hide().empty();
    });

}
// TODO: FIX THIS
function refreshColModel(type) {
    var config = $.ezdia.config.pageParams;
    var data = 'accountName=' + config.account + '&role=' + config.role + '&tab=' + config.tab;
    $.ajax({
	type: "GET",
	url: 'GetColModel.htm',
	data: data,
	dataType: 'json',
	success: function(response) {
	    if(type == 'export') {
		config.exportCols = response.exportCols;
	    }
	}
    });
}

function showHideEditProfileFields(reqRoles) {
    var config = $.ezdia.config.pageParams;
    var showFields = {};
    var allRoleFields = JSON.parse(config.allRoleFieldsMap);
    $.each(allRoleFields, function(role, fields) {
        if (reqRoles.indexOf(role) > -1) {
           $.extend(showFields, fields);
        }
    });

    var fieldsArray = Object.keys(showFields);
    $('div[id$="-main"]').each(function() {
        var divId = $(this).attr('id');
        var fieldName = divId.replace('-main', '');
        if (fieldsArray.indexOf(fieldName) > -1) {
           $('#'+divId).show();
        } else {
            $('#'+divId).hide();
        }
    });
}

function youTubePopup(title, embedURL) {

    $("<div></div>").dialog({
        buttons: {"Ok": function() {
                $(this).dialog("close");
            }},
        close: function(event, ui) {
            $(this).remove();
        },
        resizable: false,
        title: title,
        width: '590',
        height: '455',
        show: { effect: "fade"},
        hide: {effect: "fade"},
        modal: true
    }).html('<iframe width="560" height="315" src="' + embedURL + '" frameborder="0" allowfullscreen></iframe>');
}

function pageLoadingDone() {
    $('#ez-body-container').removeAttr('style');
    $('#ez-page-loading').remove();
    $('body').removeClass('ez-page-loading-no-scroll');
}

function loadURL(path, params, method, target) {
    ezdia.util.loadUrl(path, params, target);
  //   method = method || "post"; // Set method to post by default if not specified.
  //   target = target || "_blank";

  //   var form = document.createElement("form");
  //   form.setAttribute("method", method);
  //   form.setAttribute("action", path);
  //   form.setAttribute("target", target);
    

  //   if (params) {
	// var paramsList = params.split('&');
	// for(var i=0;i < paramsList.length; i++ ) {
  //           var kv = paramsList[i].split('=');
			
	//     if(kv.length == 2) {
	// 	var key = kv[0];
	// 	var value = kv[1];
	// 	var hiddenField = document.createElement("input");
	// 	hiddenField.setAttribute("type", "hidden");
	// 	hiddenField.setAttribute("name", key);
	// 	hiddenField.setAttribute("value",value);
	// 	form.appendChild(hiddenField);
  //           }
	// }
  //   }

  //   document.body.appendChild(form);
  //   form.submit();
}

function checkoutItemsQAClick() {
    $('#itemCount').val('');
    var wrapper = ezdia.util.getWrapper("ez-checkout-items-wrapper");

    wrapper.html('<div class="control-group"><form id="checkoutItemsform" class="form-horizontal ezdia-form desk" method="POST"><div class="form-group" data-row="row">	    <label class="control-label" id="count_label" for="itemCount">No. of Items</label><div class="inputs" data-row="input"><input class="form-control" type="text" id="itemCount" name="itemCount"/></div></div></form></div>');
    wrapper.dialog({
        modal: true,
        title: 'Checkout Items',
        width: 800,
        height: 'auto',
        buttons: [{
            text: 'Checkout',
            class: "btn btn-primary",
            id: 'checkoutItemsQABtn',
            click: function () {
                checkoutItemsQABtn();             
            }
        },
        {
          text: 'Cancel',
          class: 'btn-link',
          click: function () {
            $(this).dialog('close');
            $('#ez-quick-action-links').find('li').removeClass('active');
          }
        }
        ]
    });    
}

function checkoutItemsQABtn() {
    var tab = $.ezdia.config.pageParams.tab;
    var activeBtn = $(this);
    activeBtn.button('loading');

    var data = "&accountName=" + $('#accountName').val();
    data += "&roleName=" + $('#role').val();
    data += "&tab=" + tab;
    data += "&itemCount=" + $('#itemCount').val();

    var valid = $('#checkoutItemsform').valid();
    
    $.ajax({
        type: "GET",
        url: 'AcceptTask.htm',
        dataType: 'text',
        data: data,
        success: function(response) {
	    $("#statusMsg").html(response);
            $("#statusMsg").dialog({
                modal: true,
                width: 'auto',
                height: 'auto',
                title: "Checkout Items",
                buttons: {
                    Ok: function() {
                        $(this).dialog("close");
                        $("#grid").trigger("reloadGrid");
                        $('#ez-quick-action-links').find('li').removeClass('active');
                        $("#ez-checkout-items-wrapper").dialog('close');
                        
                    }
                }
            }); 
	},
	error: function(response) {
            var obj = {
		response: response.responseText,
		success: false
	    };
	    successErrorDialog(obj);
	}
    }).always(function () {
      activeBtn.button('reset');
    });
};
